import Vue from 'vue'

export default {
  REMOVE (state, index) {
    const all = JSON.parse(JSON.stringify(state.all))
    delete all[index]
    state.all = all
  },
  FLUSH_ACTIVE (state) {
    state.active = false
  },
  UPDATE_BOUND (state, { key, value }) {
    state.bound[key] = value
  },
  UPDATE (state, resource) {
    const index = state.all[resource.id]
    if (index === -1) {
      Vue.set(state.all, resource.id, resource)
    } else {
      const temp = { ...state.all[resource.id], ...resource }
      Vue.set(state.all, resource.id, temp)
    }
  },
  MERGE (state, resource) {
    const newState = JSON.parse(JSON.stringify(state.all))
    // console.log(newState, resource)
    for (const r in resource) {
      // Get existing object from state, or create an empty object based on a stub
      const oldObj = state.all[r] || Object.assign({}, state.stub)
      // Merge the new data into the old object.
      const newObj = Object.assign({}, oldObj, resource[r])
      // Set new object in state.
      // Vue.set(state.all, r, newObj)
      newState[r] = newObj
    }
    state.all = newState
  },
  REPLACE_ALL (state, resource) {
    state.all = resource
  },
  SET_DYNAMIC (state, resource) {
    state[resource.key] = resource.value
  },
  updateBound (state, payload) {
    state.bound = payload
  }
}
